import { render, staticRenderFns } from "./codeModel.vue?vue&type=template&id=127f4706&scoped=true&"
import script from "./codeModel.vue?vue&type=script&lang=js&"
export * from "./codeModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f4706",
  null
  
)

export default component.exports